import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import PhoneInput from "../../../../../../components/PhoneInput/PhoneInput";
import WhatsappImg from "../../../../../images/WhatsApp.svg";
import localeText from "../../../../../../locale";

const IntegrationSidebar = ({
  visible,
  onHide,
  selectedIntegration,
  configs,
  setConfigs,
  whatsappStep,
  setWhatsappStep,
  loading,
  onSave,
  onDelete,
  onDeleteClick,
  isConnected,
  whatsappNumber,
}) => {
  useEffect(() => {
    if (selectedIntegration?.id === "whatsapp" && whatsappNumber) {
      setConfigs((prevConfigs) => ({
        ...prevConfigs,
        [`${selectedIntegration.id}_phoneNumber`]: whatsappNumber,
      }));
    }
  }, [selectedIntegration, isConnected, whatsappNumber, setConfigs]);

  return (
    <>
      <Sidebar
        visible={visible}
        position="right"
        onHide={onHide}
        style={{ width: "500px" }}
        className="p-sidebar-md"
      >
        <div className="flex flex-column h-full">
          <div className="pb-3 border-bottom-1 border-300">
            <div className="flex align-items-center gap-3 mb-2">
              <div
                className="flex align-items-center justify-content-center"
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "12px",
                  backgroundColor: `${selectedIntegration?.color}20`,
                }}
              >
                <img
                  src={selectedIntegration?.url || WhatsappImg}
                  alt={selectedIntegration?.name}
                  style={{ width: "28px", height: "28px" }}
                />
              </div>
              <div>
                <h3 className="m-0 text-xl font-semibold" style={{ color: "var(--theme-text)" }}>
                  {selectedIntegration?.name}
                </h3>
                <p className="m-0 text-sm text-color-secondary">
                  {selectedIntegration?.description}
                </p>
              </div>
            </div>
          </div>
          <div className="mb-3 p-2" style={{ backgroundColor: "#F7F7F7", color: "#A3A3A3" }}>
            {localeText("integrationData")}
          </div>

          <div className="flex-grow-1 overflow-y-auto p-fluid">
            {selectedIntegration?.isWhatsApp ? (
              <>
                {whatsappStep === 1 ? (
                  <>
                    <div className="field mb-4">
                      <label
                        htmlFor="phoneNumber"
                        className="font-semibold mb-2 block"
                        style={{ color: "var(--theme-text)" }}
                      >
                        {localeText("phoneNumber1")}
                      </label>
                      <PhoneInput
                        value={configs[`${selectedIntegration.id}_phoneNumber`] || ""}
                        onChange={(value) =>
                          setConfigs({
                            ...configs,
                            [`${selectedIntegration.id}_phoneNumber`]: value || "",
                          })
                        }
                        disabled={loading || isConnected}
                        placeholder={localeText("enterYourPhoneNumber")}
                        defaultCountry="BR"
                      />

                      {isConnected && (
                        <Button
                          label={localeText("removeIntegration")}
                          icon="pi pi-trash"
                          className="mb-3 mt-4 text-left p-0 text-sm hover:underline font-medium"
                          style={{
                            borderColor: "#EF4444",
                            color: "#EF4444",
                            backgroundColor: "transparent",
                          }}
                          onClick={onDeleteClick}
                          disabled={loading}
                          loading={loading}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <Button
                      label={localeText("goBackAndResendCode")}
                      icon="pi pi-arrow-left text-left"
                      className="p-button-text p-button-sm w-auto"
                      onClick={() => setWhatsappStep(1)}
                      disabled={loading}
                    />

                    <div className="field mb-4">
                      <label htmlFor="confirmationCode" className="font-semibold mb-2 block">
                        {localeText("confirmationCode")}
                      </label>
                      <InputText
                        id="confirmationCode"
                        className="w-full"
                        placeholder={localeText("enterReceivedCode")}
                        value={configs[`${selectedIntegration.id}_confirmationCode`] || ""}
                        onChange={(e) =>
                          setConfigs({
                            ...configs,
                            [`${selectedIntegration.id}_confirmationCode`]: e.target.value,
                          })
                        }
                        disabled={loading}
                        autoFocus
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {selectedIntegration?.fields?.map((field) => (
                  <div key={field.key} className="field mb-4">
                    <label htmlFor={field.key} className="font-semibold mb-2 block">
                      {field.label}
                    </label>
                    {field.type === "textarea" ? (
                      <InputTextarea
                        id={field.key}
                        rows={3}
                        className="w-full"
                        value={configs[`${selectedIntegration.id}_${field.key}`] || ""}
                        onChange={(e) =>
                          setConfigs({
                            ...configs,
                            [`${selectedIntegration.id}_${field.key}`]: e.target.value,
                          })
                        }
                      />
                    ) : (
                      <InputText
                        id={field.key}
                        className="w-full"
                        value={configs[`${selectedIntegration.id}_${field.key}`] || ""}
                        onChange={(e) =>
                          setConfigs({
                            ...configs,
                            [`${selectedIntegration.id}_${field.key}`]: e.target.value,
                          })
                        }
                      />
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
          {/* Footer */}
          <div className="pt-3 mt-3 border-top-1 border-300">
            <div className="flex gap-2">
              <Button
                label={localeText("cancel")}
                className="p-button-outlined flex-1"
                style={{ backgroundColor: "#0A0D1408", borderColor: "#EBEBEB", color: "#5C5C5C" }}
                onClick={onHide}
                disabled={loading}
              />

              {selectedIntegration?.isWhatsApp && (
                <>
                  {!isConnected ? (
                    <Button
                      label={
                        whatsappStep === 1 ? localeText("activate") : localeText("confirmCode")
                      }
                      className="p-button-success flex-1"
                      style={{ backgroundColor: "var(--theme-primary)" }}
                      onClick={onSave}
                      disabled={loading}
                      loading={loading}
                    />
                  ) : (
                    <Button
                      label={localeText("removeIntegration")}
                      className="p-button-danger flex-1"
                      onClick={onDeleteClick}
                      disabled={loading}
                      loading={loading}
                    />
                  )}
                </>
              )}

              {!selectedIntegration?.isWhatsApp && (
                <Button
                  label={localeText("save")}
                  className="p-button-success flex-1"
                  style={{ backgroundColor: "var(--theme-primary)" }}
                  onClick={onSave}
                  disabled={loading}
                  loading={loading}
                />
              )}
            </div>
          </div>
        </div>
      </Sidebar>
    </>
  );
};

export default IntegrationSidebar;
